export default __webpack_public_path__ + "static/media/show_more_work.5acb2bd8.svg";